////
/// ============================================================================
/// COMPONENT / Accordion
/// ============================================================================
///
/// @group components
////

export default () => {

    let historySupport = window.history && window.history.replaceState;

    function toggle(accordion, item, trigger, forceOpen) {
        // item deve far parte dell’accordion
        if (!item.classList.contains('js-accordion__item')) {
            return;
        }

        if (!trigger) {
            trigger = item.querySelector('.js-accordion__trigger');
        }

        if (!forceOpen && item.classList.contains('is-open')) {
            accordion.dispatchEvent(new CustomEvent('before_close', {detail: {item: item}}));

            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');

            if (historySupport) {
                window.history.replaceState(null, document.title, window.location.pathname);
            } else {
                window.location.hash = '';
            }

            accordion.dispatchEvent(new CustomEvent('after_close', {detail: {item: item}}));
        } else {
            accordion.dispatchEvent(new CustomEvent('before_open', {detail: {item: item}}));

            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');

            if (item.hasAttribute('id')) {
                let hash = '#' + item.getAttribute('id');
                if (historySupport && item.hasAttribute('id')) {
                    window.history.replaceState(null, document.title, window.location.pathname + hash);
                } else {
                    window.location.hash = hash;
                }
            }

            accordion.dispatchEvent(new CustomEvent('after_open', {detail: {item: item}}));
        }
    }

    // is current url hashed?
    (function () {
        let hash = window.location.hash;

        if (hash === '' || hash === '#') {
            return;
        }

        // normalize
        if (hash.substring(0, 1) !== '#') {
            hash = '#' + hash;
        }

        let item = document.querySelector(hash);

        if (!item) {
            return;
        }

        let accordion = item.closest(".js-accordion");

        toggle(accordion, item, null, true);
    }());

    document.querySelectorAll('.js-accordion').forEach(function (accordion) {
        // init
        let i = 1;
        let collapsible = accordion.dataset.accordionCollapsible === "true";
        accordion.querySelectorAll('.js-accordion__item').forEach(function (item) {
            let trigger = item.querySelector('.js-accordion__trigger');
            let panel = item.querySelector('.js-accordion__panel');

            // aria tags
            trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
            trigger.setAttribute('aria-controls', 'accordion-panel-' + i);
            trigger.setAttribute('id', 'accordion-trigger-' + i);
            panel.setAttribute('aria-labelledby', 'accordion-trigger-' + i);
            panel.setAttribute('id', 'accordion-panel-' + i);

            i++;
        });

        // click event
        accordion.addEventListener('click', function (event) {
            let trigger = event.target.closest('.js-accordion__trigger');

            if (trigger) {
                if (collapsible) {
                    accordion.querySelectorAll('.js-accordion__item').forEach(function (item) {
                        item.classList.remove('is-open');
                        item.querySelector('.js-accordion__trigger').setAttribute('aria-expanded', 'false');
                    });
                }

                let item = trigger.closest('.js-accordion__item');

                toggle(accordion, item, trigger);
            }
        });
    });

};
